export {default} from './NewInfoPopover';
